// Designer Toggles
class Designer {
  constructor() {
    const gridItems = document.querySelector('.designer-landing__list');

    this.gridToggles = [].slice.call(
      document.querySelectorAll('.designer-landing__btn')
    );

    this.gridToggles.forEach(toggle => {
      // ada : support keyboard
      ['click', 'keypress'].forEach(event => {
        toggle.addEventListener(event, e => {
          const key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            [].forEach.call(document.querySelectorAll('.designer-landing__btn'), function (el) {
              el.classList.remove('active');
            });
            toggle.classList.add('active');

            if (toggle.classList.contains('designer-landing__btn--primary')) {
              gridItems.classList.remove('no-image')
            } else {
              gridItems.classList.add('no-image')
            }
          }
        });
      });
    });
  }
}

const designerInit = {
  init() {
    // if element exists init this class
    const wrapperEl = document.getElementById('designer-landing');
    if (wrapperEl !== null) {
      // eslint-disable-next-line no-unused-vars
      const pdp = new Designer(wrapperEl);
    }
  },
};

export default designerInit;
